module.exports = __webpack_public_path__ + "img/cup_platinum.942a4125.svg";